import React, { useState } from 'react';
import { styled, Box, IconButton } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showBorderBottom',
})<{
  showBorderBottom: boolean;
  gridTemplateColumns: string;
}>(({ showBorderBottom, gridTemplateColumns }) => ({
  border: '1px solid #D8D8D8',
  borderBottom: showBorderBottom ? '1px solid #D8D8D8' : 'none',
  display: 'grid',
  gridTemplateColumns,
  maxWidth: '100%',
  padding: 8,
  alignItems: 'center',
  cursor: 'pointer',
}));

const StyledExpandedBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showBorderBottom',
})<{ showBorderBottom: boolean }>(({ showBorderBottom }) => ({
  padding: '12px 18px',
  border: '1px solid #D8D8D8',
  borderTop: 'none',
  borderBottom: showBorderBottom ? '1px solid #D8D8D8' : 'none',
}));

const StyledIconButton = styled(IconButton)(() => ({
  maxWidth: 'fit-content',
}));

interface EqualisationsConcertinaProps {
  expandedContent: React.ReactNode;
  isLastElement: boolean;
  concertinaItems: Array<React.ReactNode>;
  gridTemplateColumns: string;
  isExpandedByDefault?: boolean;
}

const EqualisationsConcertina: React.FC<EqualisationsConcertinaProps> = ({
  isLastElement,
  expandedContent,
  concertinaItems,
  gridTemplateColumns,
  isExpandedByDefault = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(isExpandedByDefault);

  return (
    <>
      <StyledBox
        onClick={() => setIsExpanded(!isExpanded)}
        showBorderBottom={isLastElement || isExpanded}
        gridTemplateColumns={gridTemplateColumns}
      >
        {concertinaItems}
        <StyledIconButton size="small">
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </StyledIconButton>
      </StyledBox>
      {isExpanded && (
        <StyledExpandedBox showBorderBottom={isLastElement}>
          {expandedContent}
        </StyledExpandedBox>
      )}
    </>
  );
};

export default EqualisationsConcertina;
